import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import i18n from '../i18n';

const fallbackForRole = (role) => {
  switch (role) {
    case 'super_admin':   return '/superadmin';
    case 'tenant_admin':
    case 'agency_owner':  return '/admin/dashboard';
    case 'agent':         return '/manager/dashboard';
    case 'creator':       return '/my/dashboard';
    default:              return '/login-authentication';
  }
};

const ProtectedRoute = ({ element, allowedRoles }) => {
  const [status, setStatus] = useState('loading');
  const [role, setRole] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (cancelled) return;
        if (!user) { setStatus('unauthenticated'); return; }

        const { data: profile } = await supabase
          .from('profiles')
          .select('role, language')
          .eq('id', user.id)
          .single();

        if (cancelled) return;
        setRole(profile?.role || null);
        if (profile?.language && profile.language !== i18n.language) {
          await i18n.changeLanguage(profile.language);
        }
        setStatus('done');
      } catch {
        if (!cancelled) setStatus('unauthenticated');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login-authentication" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to={fallbackForRole(role)} replace />;
  }

  return element;
};

export default ProtectedRoute;
